if (!customElements.get('insurance-option')) {
  customElements.define(
    'insurance-option',
    class InsuranceOption extends HTMLElement {
      constructor() {
        super();
        this.checkbox = this.querySelector('.insurance-option__checkbox');
        this.fees = JSON.parse(this.querySelector('[data-insurance-fees]').textContent);
        this.prices = JSON.parse(this.querySelector('[data-insurance-prices]').textContent);
        this.form = this.closest('form');
        this.checkbox.addEventListener('change', () => this.toggleDynamicCheckout());
      }

      connectedCallback() {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.variant) this.update(data.variant.id);
        });
        const current = this.form?.querySelector('[name="id"]')?.value;
        if (current) this.update(current);
        this.toggleDynamicCheckout();
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      // Insurance variant ({ id, label }) for the given product variant, or null.
      feeFor(variantId) {
        const variant = this.prices[variantId];
        if (!variant) return null;
        return this.fees[Math.round(variant.price / 100)] || null;
      }

      update(variantId) {
        const fee = this.feeFor(variantId);
        this.hidden = !fee;
        if (!fee) {
          this.checkbox.checked = false;
          this.toggleDynamicCheckout();
          return;
        }
        this.querySelector('[data-insurance-price]').textContent = fee.label;
      }

      // "Buy it now" skips the cart, so it can't carry the insurance line.
      toggleDynamicCheckout() {
        const button = this.closest('product-form')?.querySelector('.shopify-payment-button');
        if (button) button.hidden = this.checkbox.checked;
      }

      // Rewrites the product form data into a two-line cart/add request
      // (product + insurance) when the box is ticked.
      apply(formData) {
        if (!this.checkbox.checked || this.hidden) return;
        const variantId = formData.get('id');
        const fee = this.feeFor(variantId);
        if (!fee) return;

        const quantity = formData.get('quantity') || '1';
        const variant = this.prices[variantId];
        const label =
          variant.title && variant.title !== 'Default Title'
            ? `${this.dataset.productTitle} - ${variant.title}`
            : this.dataset.productTitle;

        for (const [key, value] of [...formData.entries()]) {
          if (key === 'id' || key === 'quantity' || key === 'selling_plan') {
            formData.append(`items[0][${key}]`, value);
            formData.delete(key);
          } else if (key.startsWith('properties[')) {
            formData.append(`items[0]${key.replace('properties[', '[properties][')}`, value);
            formData.delete(key);
          }
        }
        if (!formData.has('items[0][quantity]')) formData.append('items[0][quantity]', quantity);

        formData.append('items[1][id]', fee.id);
        formData.append('items[1][quantity]', quantity);
        formData.append('items[1][properties][Produs asigurat]', label);
        formData.append('items[1][properties][_asigurare_pentru]', variantId);
      }
    }
  );
}
